var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.row.valueIsHtml)?_c('span',{key:"html",domProps:{"innerHTML":_vm._f("xss")(_vm.row.value)}}):_c('span',{key:"text"},[_vm._v(_vm._s(_vm.row.value))])
}
var staticRenderFns = []

export { render, staticRenderFns }